/**
 * Danh sách gợi ý mã ngân hàng (BIN 6 số theo chuẩn NAPAS) để người khai không phải nhớ số.
 *
 * ⚠️ Đây CHỈ là tiện ích gõ nhanh, không phải nguồn sự thật. Ô nhập vẫn cho gõ tay mã
 * bất kỳ gồm 6 chữ số, vì danh sách này không đầy đủ và có thể lạc hậu.
 *
 * Khai sai BIN thì hóa đơn của chi nhánh sẽ trượt whitelist BR-202 và nhân viên không
 * quét được — nên cách chắc ăn nhất là đối chiếu với chính mã QR in trên bill.
 */
export interface BankOption {
  bin: string;
  shortName: string;
  fullName: string;
}

export const BANK_OPTIONS: readonly BankOption[] = [
  { bin: '970436', shortName: 'Vietcombank', fullName: 'NH TMCP Ngoại thương Việt Nam' },
  { bin: '970415', shortName: 'VietinBank', fullName: 'NH TMCP Công thương Việt Nam' },
  { bin: '970418', shortName: 'BIDV', fullName: 'NH TMCP Đầu tư và Phát triển Việt Nam' },
  { bin: '970405', shortName: 'Agribank', fullName: 'NH Nông nghiệp và Phát triển Nông thôn' },
  { bin: '970407', shortName: 'Techcombank', fullName: 'NH TMCP Kỹ thương Việt Nam' },
  { bin: '970416', shortName: 'ACB', fullName: 'NH TMCP Á Châu' },
  { bin: '970422', shortName: 'MB Bank', fullName: 'NH TMCP Quân đội' },
  { bin: '970432', shortName: 'VPBank', fullName: 'NH TMCP Việt Nam Thịnh Vượng' },
  { bin: '970403', shortName: 'Sacombank', fullName: 'NH TMCP Sài Gòn Thương Tín' },
  { bin: '970423', shortName: 'TPBank', fullName: 'NH TMCP Tiên Phong' },
  { bin: '970443', shortName: 'SHB', fullName: 'NH TMCP Sài Gòn - Hà Nội' },
  { bin: '970441', shortName: 'VIB', fullName: 'NH TMCP Quốc tế Việt Nam' },
  { bin: '970437', shortName: 'HDBank', fullName: 'NH TMCP Phát triển TP.HCM' },
  { bin: '970448', shortName: 'OCB', fullName: 'NH TMCP Phương Đông' },
  { bin: '970426', shortName: 'MSB', fullName: 'NH TMCP Hàng hải Việt Nam' },
];

const BY_BIN = new Map(BANK_OPTIONS.map((x) => [x.bin, x]));

/** Trả về tên ngắn nếu biết, không thì trả lại chính mã — không bịa tên ngân hàng. */
export const bankLabel = (bin: string): string => BY_BIN.get(bin)?.shortName ?? bin;
